import Box from '@mui/material/Box';
import { createFileRoute } from '@tanstack/react-router';

import { AuthHandler } from '@/features/auth';
import { Dashboard, DashboardFiltersSchema } from '@/features/dashboard';
import {
  loadAndValidatePermissions,
  miniDrawerWidth,
  Sidebar,
} from '@/features/navigation';
import { PlatformProvider } from '@/features/users';

export const Route = createFileRoute('/')({
  validateSearch: DashboardFiltersSchema,
  beforeLoad: async ({ context, location }) => {
    await loadAndValidatePermissions(context, location);
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AuthHandler>
      <PlatformProvider>
        <Box display='flex' position='relative' minHeight='100dvh'>
          <Sidebar />
          <Box
            component='main'
            flexGrow={1}
            width='100%'
            ml={`${miniDrawerWidth.toString()}px`}
          >
            <Dashboard />
          </Box>
        </Box>
      </PlatformProvider>
    </AuthHandler>
  );
}
